import React from 'react'
// possible values
// false - nav is not collapsed
// 'user' - left side nav has been minimized by user
// 'viewport' - mobile nav mode is active due to narrow viewport
// 'viewport-expanded' - mobile nav mode is active due to narrow viewport, and the user has expanded it
export const NavToggleCollapseContext = React.createContext(() => {})
export const NavCollapseContext = React.createContext(false)

// higher-order function to consume collapse state in a component definition
export const withCollapseState = Component => props => (
  <NavCollapseContext.Consumer>
    {(collapseState) => <Component collapseState={collapseState} {...props} />}
  </NavCollapseContext.Consumer>
)

// hide children when we collapse to mobile view
export const MobileCollapse = ({children}) => (
  <NavCollapseContext.Consumer>
    {(collapseState) => (collapseState === 'viewport' || collapseState === 'viewport-expanded')
      ? null
      : children}
  </NavCollapseContext.Consumer>
)

export const withToggleCollapse = Component => props => (
  <NavToggleCollapseContext.Consumer>
    {(toggleCollapse) => <Component toggleCollapse={toggleCollapse} {...props} />}
  </NavToggleCollapseContext.Consumer>
)
